interface BroadcastIdArgs {
  broadcastId: number;
}

export const broadcastPaths = {
  list: () => "/settings/emails/broadcast",
  edit: ({ broadcastId }: BroadcastIdArgs) =>
    `/settings/emails/broadcast/${broadcastId}/edit`,
  visualBuilder: ({ broadcastId }: BroadcastIdArgs) =>
    `/settings/emails/broadcast/${broadcastId}/visual-builder`,
  content: ({ broadcastId }: BroadcastIdArgs) =>
    `/settings/emails/broadcast/${broadcastId}/content`,
  view: ({ broadcastId }: BroadcastIdArgs) =>
    `/settings/emails/broadcast/${broadcastId}/view`,
  viewAnalytics: ({ broadcastId }: BroadcastIdArgs) =>
    `/settings/emails/broadcast/${broadcastId}/view/analytics`,
} as const;
